import type { Tweet } from "react-tweet/api";
import { z } from "zod";

const tweetSchema = z.custom<Tweet>(
  (value) => typeof value === "object" && value !== null
);

export const tweetsApiResponseSchema = z.object({
  tweets: z.array(
    z.object({
      tweetId: z.string().min(1),
      tweet: tweetSchema.nullable(),
    })
  ),
});

export type TweetsApiResponse = z.infer<typeof tweetsApiResponseSchema>;
